import { useState, useEffect } from 'react';
import type { StepContentProps } from '~/ui-rocco/multi-step-form';
import { HdeOptionList } from '../HDEOptionList';

const APPLICATION_TYPE_OPTIONS = [
    {
        value: 'Homeowner',
        label: 'Homeowner',
        description: 'I am a homeowner looking to build or renovate',
    },
    {
        value: 'Professional',
        label: 'Professional',
        description:
            'I am a professional in the Design or Build Industry and am interested in attending as a guest',
    },
    {
        value: 'Exhibitor',
        label: 'Exhibitor',
        description:
            'I am a professional or product supplier in the Design or Building Industry looking to exhibit at the event',
    },
] as const;

type ApplicationType = (typeof APPLICATION_TYPE_OPTIONS)[number]['value'];

interface ApplicationTypeStepData {
    applicationType: ApplicationType | null;
    onApplicationTypeSelected?: (type: ApplicationType) => void;
}

export function HDEApplicationTypeStep({
    setIsValid,
    onDataChange,
    onNext,
    initialData,
}: StepContentProps) {
    const data = initialData as ApplicationTypeStepData | undefined;
    const onApplicationTypeSelected = data?.onApplicationTypeSelected;

    const [applicationType, setApplicationType] =
        useState<ApplicationType | null>(data?.applicationType ?? null);

    useEffect(() => {
        const isValid = applicationType !== null;
        setIsValid(isValid);
        onDataChange?.({ applicationType });
    }, [applicationType, setIsValid, onDataChange]);

    const handleChange = (value: string) => {
        const type = value as ApplicationType;
        setApplicationType(type);
        onDataChange?.({ applicationType: type });
        onApplicationTypeSelected?.(type);
        onNext();
    };

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <HdeOptionList
                label="FIRST, PLEASE TELL US WHO YOU ARE."
                options={APPLICATION_TYPE_OPTIONS}
                mode="single"
                value={applicationType}
                onChange={handleChange}
                appearance="arrow"
                optionVariant="with-description"
            />
        </div>
    );
}
